const filterSection = document.querySelector('.filters-section');
document.addEventListener('click', function (event) {
    const clickedLink = event.target.closest('a.change-collection');
    const changeSort = event.target.closest('a.change-sorting');
    const dektopToggle = event.target.closest('.op-desk');
    const mobileToggle = event.target.closest('.op-mob');
    if (clickedLink) //filter load
    {
        event.preventDefault();
        const url = new URL(clickedLink.href);
        fetchCollection(url,true);
        window.history.pushState(null, "", url);
    }else if (changeSort) //sort load
    {
        event.preventDefault();
        const sortValue = changeSort.getAttribute('href');
        const url = new URL(window.location.href);
        document.querySelector('.filters-section').classList.toggle('open-desk');
        url.searchParams.set('sort_by', sortValue);
        url.searchParams.delete('page');
        // Preserve search query if on search page
        const isSearchPage = url.pathname === '/search' || url.pathname.includes('/search');
        if (isSearchPage && !url.searchParams.has('q')) {
            // Try to get search query from current page
            const currentQ = new URLSearchParams(window.location.search).get('q');
            if (currentQ) {
                url.searchParams.set('q', currentQ);
            }
        }
        fetchCollection(url,true);
        window.history.pushState(null, "", url);
    }else if (dektopToggle) //desktop open filter
    {
        event.preventDefault();
        filterSection.classList.toggle('open-desk');
        event.target.closest('.right-filter')? filterSection.setAttribute('data-fs','sort'):filterSection.setAttribute('data-fs','filter');

        if(event.target.getAttribute('data-level'))
        {
            filterSection.setAttribute('show-set', event.target.getAttribute('data-level'));
        }
    }else if (mobileToggle) //desktop open filter
    {
        event.preventDefault();
        filterSection.classList.toggle('open-mobile');
        filterSection.setAttribute('data-mob-view', event.target.getAttribute('href'));
        document.querySelector('body').classList.toggle('overflow-hidden-mobile');
    }else
    {
        return;
    }
});

document.querySelector(".filter-ajax")?.addEventListener("mouseleave", () => {
    document.querySelector(".filters-section")?.classList.remove("open-desk");
});

if (!document.querySelector('.left-filter .filter-set')) {
    document.querySelector('.left-filter').style.visibility = 'hidden';
}


function fetchCollection(url,filter)
{
    const queryString = url.search.slice(1);
    const mainurl = url.toString().split("?")[0];
    
    // Detect if we're on a search page or collection page
    const isSearchPage = url.pathname === '/search' || url.pathname.includes('/search');
    const sectionId = isSearchPage ? 'main-search' : 'zpro-collection';
    const requestUrl = `${mainurl}/?section_id=${sectionId}&${queryString}`;

    // Fetch the content
    fetch(requestUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            // Create a temporary DOM element to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Extract and insert content for the '.collection' class
            const collectionContent = tempDiv.querySelector('.filter-ajax');
            if (collectionContent) {
                const collectionWrap = document.querySelector('.filter-ajax');
                if (collectionWrap) {
                    collectionWrap.innerHTML = collectionContent.innerHTML;
                }
            }

            // Extract and insert content for the '.filter' class

            const filterContent = tempDiv.querySelector('collectionload');
            if (filterContent) {
                const filterWrap = document.querySelector('collectionload');
                if (filterWrap) {
                    filterWrap.innerHTML = filterContent.innerHTML;
                }
            }

            window.scrollTo(0, 0);
        })
        .catch(error => {
            console.error('Error loading content:', error);
        });
}

//next page
document.addEventListener('click', function (event) {
    const clickedLink = event.target.closest('a.collection-next');
    if (!clickedLink) return;

    const newUrl = clickedLink.href;
    event.preventDefault();
    window.history.pushState(null, "", newUrl);

    // Fetch content from the new URL
    fetch(newUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            const newProducts = tempDiv.querySelector('.jlc-products');
            if (newProducts) {
                const currentProducts = document.querySelector('.jlc-products');
                if (currentProducts) {
                    currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                }
            }

            const newPagination = tempDiv.querySelector('.jl-pagination');
            if (newPagination) {
                const currentPagination = document.querySelector('.jl-pagination');
                if (currentPagination) {
                    currentPagination.innerHTML = newPagination.innerHTML;
                }
            }
        })
        .catch(error => {
            console.error('Error loading content:', error);
        });
});


document.addEventListener("DOMContentLoaded", function () {
    let isThrottled = false; // Flag to control the delay

    // Function to check if an element is in the viewport
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Scroll event listener | disabled
    /*
    window.addEventListener("scroll", function () {
        if (isThrottled) return; // Skip execution if throttled

        const nextButton = document.querySelector(".collection-next");

        if (nextButton && isInViewport(nextButton)) {
            nextButton.click(); // Automatically click the button
            console.log("call");
            isThrottled = true; // Set throttle flag

            // Reset the throttle flag after 4 seconds
            setTimeout(() => {
                isThrottled = false;
            }, 1000);
        }
    });*/
});


//look book

document.querySelectorAll('.jscl-banner .banner').forEach(banner => {
    banner.addEventListener('click', (e) => {
        e.preventDefault();
        const parentBanner = banner.closest('.jscl-banner');
        const popup = parentBanner.nextElementSibling;
        if (popup && popup.classList.contains('fix-popup-new')) {
            popup.classList.add('active');
            document.body.classList.add('ohide');
            document.documentElement.classList.add('ohide');
        }
    });
});

document.querySelectorAll('.closepops').forEach(el => {
    el.addEventListener('click', (e) => {
        document.querySelectorAll('.fix-popup-new').forEach(popup => {
            popup.classList.remove('active');
            e.preventDefault();
        });
        document.body.classList.remove('ohide');
        document.documentElement.classList.remove('ohide');
    });
});


